import { SISTER_BRAND_URL } from "@/lib/constants";

export default function SisterBrand() {
  return (
    <section
      id="desserts"
      data-testid="sister-brand-section"
      className="section bg-rose-soft relative"
    >
      <div className="mx-auto max-w-6xl grid lg:grid-cols-2 gap-10 items-center">
        <div className="relative">
          <div className="absolute -inset-2 rounded-[2rem] bg-[hsl(var(--gold)/0.2)] -rotate-1" />
          <div className="relative recipe-card overflow-hidden">
            <img
              src="https://images.unsplash.com/photo-1535254973040-607b474cb50d?auto=format&fit=crop&w=1000&q=80"
              alt="Handcrafted dessert table by Central Florida Custom Cakes"
              className="w-full h-72 sm:h-96 object-cover"
              loading="lazy"
            />
            <div className="px-6 py-5 bg-[hsl(var(--cream))]">
              <div className="font-script text-2xl text-[hsl(var(--rose-deep))]">
                our sister brand
              </div>
              <div className="font-serif-display text-xl text-[hsl(var(--brown))]">
                Central Florida Custom Cakes
              </div>
            </div>
          </div>
        </div>

        <div>
          <span className="eyebrow left">complete the table</span>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[hsl(var(--brown))]">
            Complete the table with{" "}
            <span className="font-script text-[hsl(var(--gold-deep))]">
              handcrafted
            </span>{" "}
            desserts.
          </h2>
          <p className="mt-5 text-[hsl(var(--brown-soft))] leading-relaxed">
            Heritage Table Catering is connected with{" "}
            <strong className="text-[hsl(var(--brown))]">
              Central Florida Custom Cakes
            </strong>
            , allowing families and event hosts to pair homestyle catering
            with custom cakes, pies, cookies, cupcakes, and beautiful dessert
            tables.
          </p>

          <ul className="mt-6 grid grid-cols-2 gap-2.5">
            {[
              "Wedding cakes",
              "Custom pies",
              "Cookies & bars",
              "Cupcakes",
              "Dessert tables",
              "Church dessert spreads",
            ].map((i) => (
              <li
                key={i}
                className="text-sm text-[hsl(var(--brown))] flex items-center gap-2"
              >
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-[hsl(var(--gold-deep))]" />
                {i}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-wrap items-center gap-4">
            <a
              href={SISTER_BRAND_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="sister-brand-cta"
              className="btn-pill btn-primary"
              style={{ background: "hsl(var(--gold-deep))" }}
            >
              Explore Custom Cakes
              <span aria-hidden>↗</span>
            </a>
            <a
              href="#quote"
              data-testid="sister-brand-bundle-cta"
              className="btn-pill btn-secondary"
            >
              Bundle catering + dessert
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
